import { NgModule } from '@angular/core';
import { ThemeComponent } from './theme.component';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from "../auth/_guards/auth.guard";

const routes: Routes = [
    {
        "path": "",
        "component": ThemeComponent,
        "canActivate": [AuthGuard],
        "children": [
            {
                "path": "index",
                "loadChildren": "./pages/aside-left-display-disabled-loader-enabled-enabled-type-spinner-message/index/index.module#IndexModule"
            },
            {
                "path": "inner",
                "loadChildren": "./pages/default/inner/inner.module#InnerModule"
            },
            {
                "path": "inner2",
                "loadChildren": "./pages/default/inner2/inner2.module#Inner2Module"
            },
            {
                "path": "profile",
                "loadChildren": "./pages/default/profile/profile.module#ProfileModule"
            },
            {
                "path": "sucursales",
                "loadChildren": "./pages/sucursales/lista-sucursales/lista-sucursales.module#ListaSucursalesModule"
            },
            {
                "path": "academias",
                "loadChildren": "./pages/academias/lista-academias/lista-academias.module#ListaAcademiasModule"
            },
            {
                "path": "clientes",
                "loadChildren": "./pages/clientes/lista-clientes/lista-clientes.module#ListaClientesModule"
            },
            {
                "path": "usuarios",
                "loadChildren": "./pages/usuarios/lista-usuarios/lista-usuarios.module#ListaUsuariosModule"
            },
            {
                "path": "cupones",
                "loadChildren": "./pages/cupones/content/cupones-content.module#CuponesContentModule"
            },
            {
                "path": "campanias",
                "loadChildren": "./pages/campanias/content/campanias-content.module#CampaniasContentModule"
            },
            {
                "path": "campanias_p",
                "loadChildren": "./pages/campanias/plantillas/plantillas.module#PlantillasModule"
            },
            {
                "path": "configuraciones",
                "loadChildren": "./pages/configuraciones/content-conf/content-conf.module#ContentConfModule"
            },
            {
                "path": "404",
                "loadChildren": "./pages/default/not-found/not-found.module#NotFoundModule"
            },
            {
                "path": "",
                "redirectTo": "index",
                "pathMatch": "full"
            },

        ]
    },
    {
        "path": "**",
        "redirectTo": "404",
        "pathMatch": "full"
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class ThemeRoutingModule {
}


// WEBPACK FOOTER //
// ./src/app/theme/theme-routing.module.ts